import { Stack } from '@hotjar/hotsauce';
import type { ReactionStyle } from '@hotjar/feedback/domain/Surveys/Questions/SurveyQuestion';
import { SurveyResponseFilterChain } from './SurveyResponseFilterChain';
import { SurveyResponseLocalFilters } from './SurveyResponseLocalFilters';

export interface SurveyResponseFiltersProps {
  hasKeywords?: boolean;
  hasRatings?: boolean;
  reactionStyle: ReactionStyle;
  isExternalLinkSurvey: boolean;
}

export const SurveyResponseFilters = ({
  hasKeywords,
  hasRatings,
  reactionStyle,
  isExternalLinkSurvey,
}: SurveyResponseFiltersProps): JSX.Element => {
  return (
    <Stack direction="column">
      <Stack spacing="x1">
        <SurveyResponseFilterChain />
      </Stack>
      <Stack spacing="x1">
        <SurveyResponseLocalFilters
          hasKeywords={hasKeywords}
          hasRatings={hasRatings}
          reactionStyle={reactionStyle}
          isExternalLinkSurvey={isExternalLinkSurvey}
        />
      </Stack>
    </Stack>
  );
};
